
import { BookingForm } from '../Commun/BookingForm';
import { Footer } from '../Commun/Footer';
import Hearder from '../Commun/Header';
import { HomeBanner } from '../HeaderBanner/HomeBanner';
import { About } from '../Pages/About';
import { Room } from '../Pages/Room';
import { Service } from '../Pages/Service';

const Home = () => {
  return (
    <>
      <div className="  p-0" style={{ fontWeight: 700 }}>
        <Hearder />
        <HomeBanner />
        <BookingForm />
        <About />
        <Room />
        <Service />
        <div className="py-5">
          <div className="container">
            <div className="text-center wow fadeInUp" data-wow-delay="0.1s">
              <h6 className="section-title text-center text-warning text-uppercase">
                Our Team
              </h6>
              <h1 className="mb-5">
                Explore Our <span className="text-warning text-uppercase">Staffs</span>
              </h1>
            </div>
            <div className="row g-4">
              <div className="col-lg-3 col-md-6 wow fadeInUp" data-wow-delay="0.1s">
                <div className="rounded shadow overflow-hidden">
                  <div className="position-relative">
                    <img className="img-fluid" src="/assets/img/team-1.jpg" alt="" />
                    <div className="position-absolute start-50 top-100 translate-middle d-flex align-items-center">
                      <button type='button' className="btn btn-square btn-warning mx-1">
                        <i className="fab fa-facebook-f" />
                      </button>
                      <button className="btn btn-square btn-warning mx-1" type='button'>
                        <i className="fab fa-twitter" />
                      </button>
                      <button className="btn btn-square btn-warning mx-1" type='button'>
                        <i className="fab fa-instagram" />
                      </button>
                    </div>
                  </div>
                  <div className="text-center p-4 mt-3">
                    <h5 className="fw-bold mb-0">Full Name</h5>
                    <small>Designation</small>
                  </div>
                </div>
              </div>
              <div className="col-lg-3 col-md-6 wow fadeInUp" data-wow-delay="0.3s">
                <div className="rounded shadow overflow-hidden">
                  <div className="position-relative">
                    <img className="img-fluid" src="/assets/img/team-2.jpg" alt="" />
                    <div className="position-absolute start-50 top-100 translate-middle d-flex align-items-center">
                       <button type='button' className="btn btn-square btn-warning mx-1">
                        <i className="fab fa-facebook-f" />
                      </button>
                      <button className="btn btn-square btn-warning mx-1" type='button'>
                        <i className="fab fa-twitter" />
                      </button>
                      <button className="btn btn-square btn-warning mx-1" type='button'>
                        <i className="fab fa-instagram" />
                      </button>
                    </div>
                  </div>
                  <div className="text-center p-4 mt-3">
                    <h5 className="fw-bold mb-0">Full Name</h5>
                    <small>Designation</small>
                  </div>
                </div>
              </div>
              <div className="col-lg-3 col-md-6 wow fadeInUp" data-wow-delay="0.5s">
                <div className="rounded shadow overflow-hidden">
                  <div className="position-relative">
                    <img className="img-fluid" src="/assets/img/team-3.jpg" alt="" />
                    <div className="position-absolute start-50 top-100 translate-middle d-flex align-items-center">
                       <button type='button' className="btn btn-square btn-warning mx-1">
                        <i className="fab fa-facebook-f" />
                      </button>
                      <button className="btn btn-square btn-warning mx-1" type='button'>
                        <i className="fab fa-twitter" />
                      </button>
                      <button className="btn btn-square btn-warning mx-1" type='button'>
                        <i className="fab fa-instagram" />
                      </button>
                    </div>
                  </div>
                  <div className="text-center p-4 mt-3">
                    <h5 className="fw-bold mb-0">Full Name</h5>
                    <small>Designation</small>
                  </div>
                </div>
              </div>
              <div className="col-lg-3 col-md-6 wow fadeInUp" data-wow-delay="0.7s">
                <div className="rounded shadow overflow-hidden">
                  <div className="position-relative">
                    <img className="img-fluid" src="/assets/img/team-4.jpg" alt="" />
                    <div className="position-absolute start-50 top-100 translate-middle d-flex align-items-center">
                      <button type='button' className="btn btn-square btn-warning mx-1">
                        <i className="fab fa-facebook-f" />
                      </button>
                      <button className="btn btn-square btn-warning mx-1" type='button'>
                        <i className="fab fa-twitter" />
                      </button>
                      <button className="btn btn-square btn-warning mx-1" type='button'>
                        <i className="fab fa-instagram" />
                      </button>
                    </div>
                  </div>
                  <div className="text-center p-4 mt-3">
                    <h5 className="fw-bold mb-0">Full Name</h5>
                    <small>Designation</small>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <Footer />
        
  {/* Back to Top */}
  <button  className="btn btn-lg btn-warning btn-lg-square back-to-top">
    <i className="bi bi-arrow-up" />
  </button>
      </div>
    </>
  )
}

export default Home;
